import { TEST_MODE_LOCAL_STORAGE_KEY } from './test-mode-key';
export { TEST_MODE_LOCAL_STORAGE_KEY };
export const getIsTestMode = ()=>!!localStorage.getItem(TEST_MODE_LOCAL_STORAGE_KEY);
// WHY: read once at module load — a jest setup file MUST set the flag before this module is
// first imported, so it imports the key from './test-mode-key' (side-effect free) instead.
export const isTestMode = getIsTestMode();
